/* eslint-disable */
import { toggle } from 'slidetoggle';

const postCatsMobileDisplay = () => {
    const postCatsTarget = document.querySelectorAll('.csLanding__asideTarget');

    postCatsTarget.forEach(el => {
        const dataTitle = el.getAttribute('data-title');
        const postCatsMenu = document.getElementById(dataTitle);

        // Setup for mobile display
        if (window.matchMedia("(max-width: 768px)").matches) {
            el.setAttribute('aria-expanded', 'false');
            el.setAttribute('aria-controls', dataTitle);
            el.setAttribute('aria-label', 'Expand Menu');
            postCatsMenu.setAttribute('aria-hidden', 'true');
            postCatsMenu.style.display = 'none';
        } else {
            // For desktop or larger displays, revert attributes and styles
            el.removeAttribute('aria-expanded');
            el.removeAttribute('aria-controls');
            el.removeAttribute('aria-label');
            postCatsMenu.removeAttribute('aria-hidden');
            postCatsMenu.style.display = 'flex'; // Adjust as necessary
        }
    });
};

const init = () => {
    const postCatsTarget = document.querySelectorAll('.csLanding__asideTarget');

    postCatsTarget.forEach(el => {
        const dataTitle = el.getAttribute('data-title');
        const postCatsMenu = document.getElementById(dataTitle);

        // Attach the click event listener only once
        el.addEventListener('click', () => {
            // Use the custom slide toggle function
            toggle(postCatsMenu, {
                miliseconds: 300,
                transitionFunction: 'ease',
                onOpen: () => {
                    el.setAttribute('aria-expanded', 'true');
                    el.setAttribute('aria-label', 'Collapse Menu');
                    postCatsMenu.setAttribute('aria-hidden', 'false');
                },
                onClose: () => {
                    el.setAttribute('aria-expanded', 'false');
                    el.setAttribute('aria-label', 'Expand Menu');
                    postCatsMenu.setAttribute('aria-hidden', 'true');
                },
                elementDisplayStyle: 'flex',

            });
        });
    });

    // Handle display logic on load and resize
    postCatsMobileDisplay();
    window.addEventListener('resize', postCatsMobileDisplay);
};

export default init;
